"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _lib = _interopRequireDefault(require("react-ionicons/lib"));

var _ref2 = _react.default.createElement("span", null, "No icon");

var Icon = function Icon(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      style = _ref.style;
  return _react.default.createElement("span", {
    className: className,
    style: (0, _extends2.default)({
      display: 'inline-block'
    }, style)
  }, icon ? _react.default.createElement(_lib.default, {
    icon: icon,
    fontSize: "1em"
  }) : _ref2);
};

var _default = Icon;
exports.default = _default;